import { useUserStore } from "@client/store/user";

/**
 * Je přihlášený uživatel administrátor?
 *
 * `useUserStore.user` je `UserSafe | null | false` (null = ještě se načítá, false = odhlášen),
 * proto ta kontrola typu. Klientský gate je vždycky jen kosmetika — skutečné omezení
 * vynucuje server (`requireAdmin` a kontrola role u WS subscribe).
 */
export const useIsAdmin = (): boolean =>
  useUserStore((s) => typeof s.user === "object" && s.user !== null && s.user.role === "ADMIN");
